module.exports = __webpack_public_path__ + "static/media/logo-white2.db214cc1.png";